import { useQuery } from '@tanstack/react-query';
import {
  getReminderImportJob,
  getReminderImportJobs,
  getReminderImportSchema,
} from '../api';

const ACTIVE_JOB_STATUSES = new Set(['pending', 'processing', 'running']);

export const reminderImportKeys = {
  all: ['reminder-import-jobs'],
  list: (companyId) => ['reminder-import-jobs', companyId],
  detail: (companyId, jobId) => ['reminder-import-job', companyId, jobId],
  schema: (companyId, templateId, templateName, channel, sendingMode) => [
    'reminder-import-schema',
    companyId,
    templateId,
    templateName,
    channel,
    sendingMode || '',
  ],
};

export function useReminderImportSchema(
  companyId,
  { templateId, templateName, channel, sendingMode } = {},
) {
  return useQuery({
    queryKey: reminderImportKeys.schema(
      companyId,
      templateId,
      templateName,
      channel,
      sendingMode,
    ),
    queryFn: () =>
      getReminderImportSchema({
        companyId,
        templateId,
        templateName,
        channel,
        sendingMode,
      }),
    enabled:
      !!companyId && (!!(templateId || templateName) || channel === 'email'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useReminderImportJobs(companyId, options = {}) {
  return useQuery({
    queryKey: reminderImportKeys.list(companyId),
    queryFn: () => getReminderImportJobs(companyId),
    enabled: !!companyId && (options.enabled ?? true),
  });
}

export function useReminderImportJob(companyId, jobId) {
  return useQuery({
    queryKey: reminderImportKeys.detail(companyId, jobId),
    queryFn: () => getReminderImportJob({ companyId, jobId }),
    enabled: !!companyId && !!jobId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return ACTIVE_JOB_STATUSES.has(status) ? 3000 : false;
    },
  });
}
